import React from 'react'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'

type Props = {
  version?: string
}

class Footer extends React.Component<Props> {
  static defaultProps = {
    // REACT_APP_* を参照
    version: (process.env.REACT_APP_VERSION as string | undefined) ?? '0.0.0'  }

  render() {
    const { version } = this.props
    return (
      <AppBar position="fixed" sx={{ top: 'auto', bottom: 0 }} color="default" component="footer">
        <Toolbar variant="dense" sx={{ minHeight: "32px" }}>
          <Typography variant="body2" sx={{ ml: 'auto' }}>
            v{version}
          </Typography>
        </Toolbar>
      </AppBar>
    )
  }
}

export default Footer
